import { gql } from "@apollo/client";

export const GENERATE_QR_CODES = gql`
  mutation GenerateQrCodesMutation($count: Int!) {
    generateQrCodes(count: $count) {
      ok
      error
      results {
        id
        code
      }
    }
  }
`;

export const QR_CODE = gql`
  query QrCodeQuery($id: Int!) {
    qrCode(id: $id) {
      ok
      error
      result {
        id
        code
        status
        generatedAt
        stockUnit {
          id
          batchNumber
        }
      }
    }
  }
`;

export const QR_CODE_BY_CODE = gql`
  query QrCodeByCodeQuery($code: String!) {
    qrCodeByCode(code: $code) {
      ok
      error
      result {
        id
        code
        status
        generatedAt
        stockUnit {
          id
          batchNumber
        }
      }
    }
  }
`;

export const QR_CODES = gql`
  query QrCodesQuery($where: QrCodesFiltersInput!) {
    qrCodes(where: $where) {
      ok
      error
      total
      results {
        id
        code
        status
        generatedAt
      }
    }
  }
`;
